<script lang="ts">
  import dayjs from 'dayjs';
  import Form from '../Form/Form.svelte';
  import Input from '../Input/Input.svelte';
  import Button from '../Button/Button.svelte';
  import { ButtonStyle } from '$shared/constants/ButtonStyle';
  import InputGroup from '../InputGroup/InputGroup.svelte';

  interface Props {
    disabled?: boolean;
    onchange?: (detail: { toDate: string; fromDate: string }) => void;
    onclear?: () => void;
  }

  let { disabled = false, onchange, onclear }: Props = $props();

  let error = $state('');
  let fromDate = $state('');
  let toDate = $state('');

  const onFromDateChange = (e: any): void => {
    fromDate = e.target.value?.trim();
    clearError();
  };

  const onToDateChange = (e: any): void => {
    toDate = e.target.value?.trim();
    clearError();
  };

  const onClickDone = (): void => {
    if (!(toDate && fromDate)) {
      error = 'Please set both From and To date';
      return;
    }

    if (!dayjs(fromDate).isSameOrBefore(toDate)) {
      error = 'To Date is not valid';
      return;
    }

    onchange?.({ toDate, fromDate });
  };

  const clearError = (): void => {
    error = '';
  };

  const onClickClear = (): void => {
    clearError();
    fromDate = null;
    toDate = null;
    onclear?.();
  };
</script>

<div class="dropdown-date-range">
  <Form {error} onalertclose={clearError}>
    <InputGroup>
      <div class="input-wrap">
        <Input
          {disabled}
          name="fromDate"
          type="date"
          label="From"
          value={fromDate}
          required={false}
          onchange={onFromDateChange}
        />
      </div>
      <div class="input-wrap">
        <Input
          {disabled}
          name="toDate"
          type="date"
          label="To"
          value={toDate}
          required={false}
          onchange={onToDateChange}
        />
      </div>
    </InputGroup>
    <div class="actions">
      <div class="action">
        <Button name="done" {disabled} style={ButtonStyle.Primary} onclick={onClickDone}
          >Done</Button
        >
      </div>
      <div class="action">
        <Button name="clear" {disabled} onclick={onClickClear}>Clear</Button>
      </div>
    </div>
  </Form>
</div>

<style>
  .dropdown-date-range {
    padding: 16px;
    box-shadow: 0px 3px 11px 1px rgba(0, 0, 0, 0.0783708), 0px 7px 18px 3px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
  }
  .actions {
    margin-top: 16px;
    display: flex;
    align-items: center;
  }
  .action:not(:last-child) {
    margin-right: 16px;
  }
</style>
